export const makePhoneCall = (phoneNumber: string | number) => {
  if (!phoneNumber) return;
  window.open(`tel:${phoneNumber}`, "_self");
};
